<script lang="ts">
	import Logo from "./Logo.svelte";
</script>

<div class="absolute inset-0 size-full bg-inherit flex items-center justify-center p-10">
	<Logo class="size-full" />
</div>
